import React, { useContext, useState } from 'react';
import { Nullable } from '../types/common';

export interface Toast {
  id: string;
  text: string;
  buttonText: string;
  action: () => Promise<void>;
}
interface ToastState {
  toast?: Toast;
}
interface ToastCtx {
  state: ToastState;
  closeToast: () => void;
  setToast: (item?: Toast) => void;
}
const ToastContext = React.createContext<Nullable<ToastCtx>>(null);

const ToastProvider: React.FC = ({ children }): JSX.Element => {
  const [toast, setToast] = useState<Toast>();
  const closeToast = (): void => setToast(undefined);
  const value = {
    state: {
      toast,
    },
    closeToast,
    setToast,
  };
  return (
    <ToastContext.Provider value={value}>{children}</ToastContext.Provider>
  );
};

const useToast = (): ToastCtx => useContext(ToastContext) as ToastCtx;

export { ToastContext, ToastProvider, useToast };
